import { render, staticRenderFns } from "./VistaHistorialAcuerdoComercial.vue?vue&type=template&id=bdfdcfe6"
import script from "./VistaHistorialAcuerdoComercial.vue?vue&type=script&lang=js"
export * from "./VistaHistorialAcuerdoComercial.vue?vue&type=script&lang=js"
import style0 from "./VistaHistorialAcuerdoComercial.vue?vue&type=style&index=0&id=bdfdcfe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports